var map = {
	"./bitget.png": 83512,
	"./coin98.png": 33584,
	"./coinbase.png": 87009,
	"./foxwallet.png": 10549,
	"./imToken.png": 37893,
	"./metaMask.png": 32730,
	"./okx.png": 34270,
	"./phantom.png": 17395,
	"./rabby.png": 43444,
	"./rainbow.png": 69036,
	"./safepal.png": 3599,
	"./tobiFun.png": 94634,
	"./tokenPocket.png": 51013,
	"./ton.png": 95504,
	"./trust.png": 49945,
	"./walletConnect.png": 34777,
	"./zerion.png": 74333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98988;